import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "top_content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content_text" }
const _hoisted_4 = { style: {"padding":"5px"} }
const _hoisted_5 = {
  key: 0,
  class: "text2"
}
const _hoisted_6 = { class: "bottom_text" }
const _hoisted_7 = { class: "text1" }



export default /*@__PURE__*/_defineComponent({
  __name: 'betCard',
  props: {
    content: {
        type: String,
        default: () => ''
    },
    infoValue: {
        type: String,
        default: () => ''
    },
    bottomText: {
        type: String,
        default: () => ''
    },
    topBackground: {
        type: String,
        default: () => '#ccc'
    },
    downBackground: {
        type: String,
        default: () => '#000'
    },
    cardImage:{
        type: String,
        default: () => '#000'
    },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bet_card",
    style: _normalizeStyle({ background: props.topBackground })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: props.cardImage,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.content), 1),
        (__props.infoValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(props.infoValue), 1),
              _cache[0] || (_cache[0] = _createTextVNode("/10K"))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "bottom_content",
      style: _normalizeStyle({ background: props.downBackground })
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('agent.validBets')), 1),
        _createElementVNode("span", null, _toDisplayString(props.bottomText), 1)
      ])
    ], 4)
  ], 4))
}
}

})